export const AAPANEL_API_CONFIG = {
  apiUrl: (import.meta as any).env?.VITE_API_URL || "https://leads.wargabiz.com.my/api-asmm/api.php",
  apiKey: (import.meta as any).env?.VITE_API_KEY || "asmm_api_sec_88e31a9b2c4d5f6e7081a2"
};

export const TURSO_CONFIG = AAPANEL_API_CONFIG;

export const getTursoClient = () => null;

/**
 * Executes a query via AJAX (fetch) directly to aaPanel MySQL Bridge API
 */
export async function executeAaPanelQuery(sql: string, args: any[] = []) {
  try {
    const res = await fetch(AAPANEL_API_CONFIG.apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-API-Key': AAPANEL_API_CONFIG.apiKey
      },
      body: JSON.stringify({ sql, args })
    });
    if (!res.ok) {
      console.warn("aaPanel API returned status:", res.status);
      return null;
    }
    return await res.json();
  } catch (err) {
    console.warn("aaPanel AJAX API query notice:", err);
    return null;
  }
}

/**
 * Executes multiple statements in batch via AJAX directly to aaPanel MySQL Bridge API
 */
export async function executeAaPanelBatch(statements: Array<{ sql: string; args: any[] }>) {
  if (!statements || statements.length === 0) return null;
  try {
    const res = await fetch(AAPANEL_API_CONFIG.apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-API-Key': AAPANEL_API_CONFIG.apiKey
      },
      body: JSON.stringify({ batch: statements })
    });
    if (!res.ok) {
      console.warn("aaPanel API batch returned status:", res.status);
      return null;
    }
    return await res.json();
  } catch (err) {
    console.warn("aaPanel AJAX API batch notice:", err);
    return null;
  }
}

/**
 * Primary database execution function: Executes queries directly on aaPanel MySQL.
 */
export async function executeTursoQuery(sql: string, args: any[] = []) {
  const aaRes = await executeAaPanelQuery(sql, args);
  if (aaRes && Array.isArray(aaRes.rows)) {
    return {
      rows: aaRes.rows,
      rowsAffected: aaRes.rowsAffected || 0,
      columns: aaRes.rows.length > 0 ? Object.keys(aaRes.rows[0]) : []
    };
  }
  return aaRes;
}

/**
 * Primary database batch execution function: Executes batches directly on aaPanel MySQL.
 */
export async function executeTursoBatch(statements: Array<{ sql: string; args: any[] }>) {
  if (!statements || statements.length === 0) return null;
  return await executeAaPanelBatch(statements);
}
